import { useLocation } from "react-router-dom";

import { AppHeader } from "./version1/components/AppHeader/AppHeader";
import { Suspense, Fragment } from "react";

import BackToTopButton from "./components/BackToTopButton";
import Footer from "./version1/components/Footer/Footer";
import "./version1/components/Footer/Footer.css";


export const RouterLayout = ({ children }) => {

    return (
        <Fragment>
            {/* <AppNavigation location={history.location} /> */}
            <AppHeader />
            <div className='container-bg' style={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
                <main style={{ flexGrow: 1 }}>
                    <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '20%' }}>Loading...</div>}>
                        {children}
                    </Suspense>
                </main>

            </div>
            <BackToTopButton />
            <Footer />
        </Fragment>

    );
};
